import { createContext, useContext, ReactNode } from "react";

interface BottomSheetContextType {
  collapse: () => void;
  expand: () => void;
  close: () => void;
  open: () => void;
}

const BottomSheetContext = createContext<BottomSheetContextType | undefined>(
  undefined,
);

interface BottomSheetProviderProps {
  children: ReactNode;
  expand: () => void;
  collapse: () => void;
  close: () => void;
  open: () => void;
}

const BottomSheetProvider = ({
  children,
  expand,
  collapse,
  close,
  open,
}: BottomSheetProviderProps) => {
  return (
    <BottomSheetContext.Provider value={{ collapse, expand, close, open }}>
      {children}
    </BottomSheetContext.Provider>
  );
};

const useBottomSheet = () => {
  const context = useContext(BottomSheetContext);
  if (context === undefined) {
    throw new Error("useBottomSheet must be used within a BottomSheetProvider");
  }
  return context;
};

export { BottomSheetProvider, useBottomSheet };
